import { Link } from "react-router-dom"

const ContactTitleComponent = () => {
    return (
        <div className="about-title">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="title-text text-center">
                        <h2>Contato</h2>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li>
                                Contato
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactTitleComponent
